import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { FC, useEffect, useState } from 'react';
import starReviewIcon from '../../../../Asset/svg/star_review.svg';
import starReviewFilledIcon from '../../../../Asset/svg/star_review_filled.svg';
import RedesignThemeProvider from '../../RedesignThemeProvider';
import RedesignImage from '../components/RedesignImage';
import RedesignModal from '../components/RedesignModal';
import { useFeedbackModalStyles } from './FeedbackModal.styles';

export type FeedbackModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (rating: number, comment: string) => void;
  title?: string;
  isSubmitting?: boolean;
  error?: string;
};

const FeedbackModal: FC<FeedbackModalProps> = ({
  open,
  onClose,
  onSubmit,
  title = "Qu'avez vous pensé de ce test ?",
  isSubmitting = false,
  error,
}) => {
  const classes = useFeedbackModalStyles();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (!open) {
      setRating(0);
      setComment('');
    }
  }, [open]);

  if (!open) {
    return null;
  }

  const handleSubmit = () => {
    if (rating === 0) return;
    onSubmit(rating, comment.trim() || 'Aucun commentaire');
  };

  return (
    <RedesignThemeProvider>
      <RedesignModal
        open={open}
        onClose={onClose}
        labelledBy="feedback-modal-title"
        paperClassName={classes.modal}
        lightBackdrop={true}>
        <IconButton className={classes.closeButton} onClick={onClose} aria-label="Fermer">
          <CloseIcon className={classes.closeIcon} />
        </IconButton>

        <div className={classes.titleBlock}>
          <h2 id="feedback-modal-title" className={classes.title}>
            {title}
          </h2>
          <div className={classes.stars}>
            {Array.from({ length: 5 }, (_, index) => {
              const starNumber = index + 1;
              const isFilled = starNumber <= rating;

              return (
                <button
                  key={starNumber}
                  type="button"
                  className={classes.starButton}
                  onClick={() => setRating(starNumber)}
                  aria-label={`${starNumber} étoile${starNumber > 1 ? 's' : ''}`}>
                  <RedesignImage
                    src={isFilled ? starReviewFilledIcon : starReviewIcon}
                    alt=""
                    className={classes.starIcon}
                  />
                </button>
              );
            })}
          </div>
        </div>

        <div className={classes.commentSection}>
          <p className={classes.commentLabel}>Ajouter un commentaire</p>
          <textarea
            className={classes.textarea}
            placeholder="Votre commentaire"
            value={comment}
            onChange={event => setComment(event.target.value)}
          />
        </div>

        {error && <p className={classes.error}>{error}</p>}

        <Button
          className={classes.submitButton}
          onClick={handleSubmit}
          disabled={rating === 0 || isSubmitting}
          fullWidth={true}>
          {isSubmitting ? 'Envoi en cours...' : 'Envoyer mon avis'}
        </Button>
      </RedesignModal>
    </RedesignThemeProvider>
  );
};

export default FeedbackModal;
